<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-multi-tab-stage-table ref="table" :items.sync="values" :toolbar="false"/>
  </r-panel>
</template>
<script>

import VueTypes from "vue-types";
import {MultiTabStageModel} from "@/modules/redactor/models/smart-offer/bundle-multi-tab/MultiTabStageModel";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RMultiTabStageTable from "@/modules/redactor/views/smart-offer/bundle-multi-tab/r-multi-tab-stage-table.vue";

export default {
  name: "r-multi-tab-stage-panel",
  components: {RMultiTabStageTable, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Stages"),
    items: VueTypes.arrayOf(MultiTabStageModel)
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>